import { apiGet, apiPost } from "./client";

export interface PendingCeremony {
  ceremony_key: string;
  tier: "quiet" | "celebration" | "major" | "defining";
  title: string;
  message: string;
  metadata?: Record<string, unknown>;
}

export interface ShareCardData {
  title: string;
  subtitle: string;
  stat_lines: string[];
  show_name: string | null;
  user_name: string;
  user_level: string;
  user_level_number: number;
  gold_star_count: number;
  total_starlets: number;
  referral_code: string | null;
  referral_url: string | null;
  ceremony_key: string;
  tier: string;
  platform_sizes: {
    linkedin: { width: number; height: number };
    instagram_story: { width: number; height: number };
    instagram_feed: { width: number; height: number };
    twitter: { width: number; height: number };
    email_sig: { width: number; height: number };
  };
}

export const ceremonyApi = {
  getPending(): Promise<PendingCeremony[]> {
    return apiGet("/api/ceremonies/pending");
  },

  markSeen(ceremonyKey: string): Promise<{ marked: boolean }> {
    return apiPost("/api/ceremonies/seen", { ceremony_key: ceremonyKey });
  },

  getShareCard(ceremonyKey: string): Promise<ShareCardData> {
    return apiGet(`/api/share-card/${encodeURIComponent(ceremonyKey)}`);
  },
};
